import { registerCssProperty } from "../utils";
import type { JBColor } from "./jb-color";
import { uniqueId } from "jb-core";
import type { JBColorGroup, JBThemeColors } from "./types";

export function defineColor(color:JBColor , name?:string){
registerCssProperty({
    name: name??color.variableName??`--${uniqueId()}`,
    syntax: "<color>",
    inherits: true,
    initialValue: color.value,
  });
}
function defineColorGroup(group:JBColorGroup){
  defineColor(group.main);
  defineColor(group.dark);
  defineColor(group.light);
  defineColor(group.contrast);
  defineColor(group.hover);
  defineColor(group.pressed);
  defineColor(group.subtle);
}
export function defineColorCodes(colors:JBThemeColors){
  defineColor(colors.neutral[0],'--jb-neutral');
  defineColorGroup(colors.primary);
  defineColorGroup(colors.secondary);
  defineColorGroup(colors.red);
  defineColorGroup(colors.green);
  defineColorGroup(colors.yellow);
  defineColor(colors.single.black);
  defineColor(colors.single.white);
  defineColor(colors.single.highlight);
  for(let i=1;i<=10;i++){
    defineColor(colors.neutral[i])
  }
}
